import React, { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { FaPlay, FaStop } from "react-icons/fa";

interface AudioPreviewButtonProps {
  src?: string | null;
}

export default function AudioPreviewButton({ src }: AudioPreviewButtonProps) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  function toggle() {
    const audio = audioRef.current;
    if (!audio) {
      return;
    }

    if (isPlaying) {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
      return;
    }

    void audio.play();
    setIsPlaying(true);
  }

  if (!src) {
    return null;
  }

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={toggle}
        title={isPlaying ? "Stop" : "Play"}
        aria-label={isPlaying ? "Stop" : "Play"}
      >
        {isPlaying ? <FaStop className="h-3.5 w-3.5" /> : <FaPlay className="h-3.5 w-3.5" />}
      </Button>
      <audio ref={audioRef} src={src} preload="none" className="hidden" onEnded={() => setIsPlaying(false)} />
    </>
  );
}
